function moduleMapWithPoints() {
	/** @type {NodeListOf<HTMLElement>} */
	const modules = document.querySelectorAll('.module.map-with-points');
	if (!modules || !modules.length) return;

	/** @param {HTMLElement} module */
	const initModule = (module) => {
		const $mapWrapper = $(module).find('.map-wrapper');
		const $points = $(module).find('.point');
		const $triggers = $(module).find('button.point-trigger');
		const $mobileTooltips = $(module).find(`.mobile-tooltips .mobile-tooltip`);

		const updateBoundaries = (id = null) => {
			if (window.matchMedia('(width < 992px)').matches) return;

			const SAFE_SPACE = 24;

			$mapWrapper.css('--map-size', `${$mapWrapper[0].clientWidth - 2 * SAFE_SPACE}px`);

			const $point = id
				? $(module).find(`.point[data-id="${id}"]`)
				: $(module).find(`.point.active`);
			if (!$point.length) return;

			const $tooltip = $point.find('.tooltip');

			const {
				width: rootWidth,
				height: rootHeight,
				x: rootX,
				y: rootY,
			} = $mapWrapper[0].getBoundingClientRect();

			const { x, y, width, height } = $tooltip[0].getBoundingClientRect();
			if (x + width > rootX + rootWidth) {
				$point[0].style.setProperty(
					'--offset-x',
					`${rootX + rootWidth - (x + width) - SAFE_SPACE}px`
				);
			}
			if (y + height > rootY + rootHeight) {
				$point[0].style.setProperty(
					'--offset-y',
					`${rootY + rootHeight - (y + height) - SAFE_SPACE}px`
				);
			}
		};

		updateBoundaries();
		$(window).on('resize', () => updateBoundaries());
		const updateActivePoint = async (id) => {
			const $trigger = $(module).find(`button.point-trigger[data-id="${id}"]`);
			const $point = $(module).find(`.point[data-id="${id}"]`);
			if ($trigger.hasClass('active') || $point.hasClass('active')) return;

			// update trigger
			$triggers.removeClass('active');
			$trigger.addClass('active');
			// update point
			$points.removeClass('active');
			$point.addClass('active');

			// update mobile tooltips
			const $mobileTooltip = $(module).find(
				`.mobile-tooltips .mobile-tooltip[data-id="${id}"]`
			);
			if ($mobileTooltips.length) {
				await $mobileTooltips.removeClass('active').stop().slideUp().promise();
			}

			$mobileTooltip.addClass('active').stop().slideDown(400);

			updateBoundaries(id);
		};

		const uncheckActivePoints = () => {
			$triggers.removeClass('active');
			$points.removeClass('active');
		};

		clickedOutside(
			'.module.map-with-points .point, .module.map-with-points button.point-trigger',
			function () {
				uncheckActivePoints();
			},
			[$points, $triggers]
		);

		$points.on('click', async function () {
			const id = $(this).attr('data-id');
			await updateActivePoint(id);
		});
		$triggers.on('click', async function () {
			const id = $(this).attr('data-id');
			await updateActivePoint(id);
		});
	};

	for (const module of modules) {
		initModule(module);
	}
}
